import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  makeStyles,
  withStyles,
  Tabs,
  Tab,
} from "@material-ui/core";
import GeneralLoanForm from "../../loanManagement/GeneralLoanForm";
import { useHistory,useLocation } from "react-router-dom";

const AntTabs = withStyles({
  root: {
    borderBottom: "1px solid #e8e8e8",
  },
  
  indicator: {
    backgroundColor: "#1890ff",
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    minWidth: "unset !important",
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    scrollbarWidth:'none',
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },
    "&$selected": {
      color: "#1890ff",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#40a9ff",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: theme.palette.background.paper,
    marginTop: "20px",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: "14px 0px" }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

const AdminPayrollNavTabs = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [tabValue, setTabValue] = useState(0);
  const tabConfig = [
    {
      label: "Quick Process",
      path: `/app/employee/payroll/generate-payslip?tab=0`,
      hasTabPanel: false,
    },
    {
      label: "Send Payslip",
      path: `/app/employee/payroll/upload-payslip?tab=1`,
      hasTabPanel: false,
    },
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = parseInt(params.get("tab"));
    console.log(tab)
    if (!isNaN(tab)) {
      setTabValue(tab);
    } else {
      setTabValue(0); // Default to the first tab if no tab is specified
    }
  }, [location.search]);

  const handleTabChange = (event, newValue) => {
    const selectedTab = tabConfig[newValue];
    setTabValue(newValue);
    if (selectedTab?.path) {
      history.push(selectedTab.path);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.demo1}>
        <AntTabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="ant example"
        >
          {tabConfig.map((tab, index) => (
            <AntTab key={index} label={tab.label} />
          ))}
        </AntTabs>
        <div>
          <TabPanel value={tabValue} index={2}>
            <GeneralLoanForm />
          </TabPanel>
        </div>
      </div>
    </div>
  );
};
export default AdminPayrollNavTabs;
